import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon, ShieldCheck } from 'lucide-react';
const HeaderGlp6TipsB = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-17190" data-mp="1mspar12bxi40">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17191" data-mp="1cu03s3bz1i2j"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17192" data-mp="1cw4asu562x71">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17193" data-mp="17vydaxc7ugh1">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17194" data-mp="132vrxchledbx">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17195" data-mp="z08xd3tjeeb1">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17196" data-mp="p3nr6f5s6x5m">
          <div className="text-left" data-id="element-17197" data-mp="k7f5sk0zq7q0">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17198" data-mp="14zljjtqv90yw">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17199" data-mp="1nrmmb76rhbdl">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17200" data-mp="1dtgl6rss499s">
        <div className="max-w-4xl mx-auto" data-id="element-17201" data-mp="1irrvf3mzklsj">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17202" data-mp="1iqgtl9d3po42">
            PERSONAL REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-2" data-id="element-17203" data-mp="7ccy1yqv7rww">
            6 Side Effects My Doctor Never Warned Me About on Semaglutide
          </h1>
          <p className="text-base sm:text-lg text-gray-600 italic mb-5" data-id="element-17204" data-mp="250fhadud7i17">
            (And How I Fixed Every Single One Without Stopping My Medication)
          </p>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-17205" data-mp="207mf9xqa6nst">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-17206" data-mp="1v9kqqxa35w9y">
              <img src="https://cdn.magicpatterns.com/uploads/qo1VVrn8u2FTESbwCETPV1/1.jpg" alt="Dr. Tom Parham" className="w-full h-full object-cover" data-id="element-17207" data-mp="1qcm0wqxggbhk" />
            </div>
            <div className="flex-1" data-id="element-17208" data-mp="1hbntrzrpznur">
              <div className="flex items-center" data-id="element-17209" data-mp="1hcp7kc04eog6">
                <div className="font-medium text-gray-900 text-lg" data-id="element-17210" data-mp="1ccbatq3yz0xg">
                  By Patricia Morrison, RN, CN
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-17211" data-mp="3bnuim1dje35j">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-17212" data-mp="36qkls0ntip7o" />
                  <span className="text-xs ml-1 font-medium" data-id="element-17213" data-mp="3e91wga7fka28">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-17214" data-mp="3j7mz0ga5n5tu">
                Chicago, IL • Former Medical Practitioner • 58 Years Old • 4
                Years on GLP-1 Medications
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-17215" data-mp="3syhm1mv869gc">
                <div className="flex items-center mr-4" data-id="element-17216" data-mp="3szsonjcxpb5v">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-17217" data-mp="2vbhivza48xwx" />
                  <span data-id="element-17218" data-mp="3090xx1en1epx">18 min read</span>
                </div>
                <div className="flex items-center" data-id="element-17219" data-mp="309j1kj3mqv7v">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-17220" data-mp="357u9upea0xnz" />
                  <span data-id="element-17221" data-mp="35agkwz0dlvay">42,372 views</span>
                </div>
              </div>
              <div className="flex items-center text-xs text-gray-500 mt-1" data-id="element-17222" data-mp="3a91hmogf5wun">
                <ShieldCheck className="h-3.5 w-3.5 text-blue-600 mr-1 flex-shrink-0" data-id="element-17223" data-mp="kh3dbp21xr4l" />
                Medically Reviewed by{' '}
                <span className="text-blue-600 underline ml-1" data-id="element-17224" data-mp="pfeny20685nv">
                  Robert Hill, MD, FACP
                </span>
              </div>
            </div>
          </div>

          <div className="my-4" data-id="element-17225" data-mp="j2alb1mwwv5u">
            <img src="https://cdn.magicpatterns.com/uploads/hE7B4t4Tu9ARxkVLjZDSCM/Title.png" alt="GLP-1 side effects" className="w-full rounded-lg shadow-lg mb-3" data-id="element-17226" data-mp="j3c27mqm0bvh" />
          </div>

          <div className="my-4 border-l-4 border-gray-800 pl-6 py-4 bg-gradient-to-r from-gray-100 to-white shadow-sm" data-id="element-17227" data-mp="s0ckrcqzzfr0">
            <p className="text-sm uppercase tracking-wide text-gray-500 mb-2 font-semibold" data-id="element-17228" data-mp="15z2kz1945vjl">
              ARTICLE SUMMARY
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic" data-id="element-17229" data-mp="1fri2xykeuk4h">
              "What a Chicago nurse discovered after three years of crushing
              depression on semaglutide:
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic mt-4" data-id="element-17230" data-mp="1ppxrpuvythat">
              6 science-backed strategies that address nausea, hair loss,
              fatigue, and the devastating 'flat feeling' without stopping your
              medication....
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic mt-4" data-id="element-17231" data-mp="28cf1qez68ap7">
              — now helping 120+ GLP-1 users monthly at her weight loss clinic."
            </p>
          </div>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-17232" data-mp="1zbqk7aakjs7k">
            <div className="mb-1 flex items-center" data-id="element-17233" data-mp="1kmkmxrvakc2b">
              <span className="font-medium mr-2" data-id="element-17234" data-mp="1pfdvyrxsm6k7">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-17235" data-mp="1boqy11zuwkp6">
              <span className="font-medium mr-2" data-id="element-17236" data-mp="1gmajaluz1xqm">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlp6TipsB;